import { render, staticRenderFns } from "./video-button.vue?vue&type=template&id=31efe7f7&scoped=true"
import script from "./video-button.vue?vue&type=script&lang=js"
export * from "./video-button.vue?vue&type=script&lang=js"
import style0 from "./video-button.vue?vue&type=style&index=0&id=31efe7f7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efe7f7",
  null
  
)

export default component.exports